import Box from '@mui/material/Box';
import ToggleButton, { ToggleButtonProps } from '@mui/material/ToggleButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

type Props = Omit<ToggleButtonProps, 'value' | 'onChange'> & {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

export const AutoSaveToggleButton = ({
  enabled,
  onChange,
  ...toggleButtonProps
}: Props): JSX.Element => {
  const button = (
    <ToggleButton
      {...toggleButtonProps}
      value="autosave"
      aria-label="Toggle auto-save"
      selected={enabled}
      onChange={() => onChange(!enabled)}
      sx={{
        gap: 0.5,
        px: 1.5,
        textTransform: 'none',
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: enabled ? 'success.main' : 'grey.400',
          transition: 'background-color 0.2s ease',
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.875rem',
          fontWeight: 500,
          color: enabled ? 'text.primary' : 'text.disabled',
          transition: 'color 0.2s ease',
        }}
      >
        Auto Save
      </Typography>
    </ToggleButton>
  );

  return (
    <Tooltip
      title={enabled ? 'Auto-save enabled' : 'Auto-save disabled'}
      placement="right"
    >
      {button}
    </Tooltip>
  );
};
